import { defineComponent as S, computed as c, openBlock as d, createBlock as b, resolveDynamicComponent as h, normalizeStyle as y, withCtx as x, createElementBlock as k } from "vue";
import { KUI_ICON_SIZE_50 as l } from "./kong-icons.es1628.js";
const z = ["aria-hidden"], u = '<path d="M8.825 12L10.3 10.525C10.5 10.325 10.6 10.0917 10.6 9.825C10.6 9.55833 10.5 9.325 10.3 9.125C10.1 8.925 9.8625 8.825 9.5875 8.825C9.3125 8.825 9.075 8.925 8.875 9.125L6.7 11.3C6.6 11.4 6.52917 11.5083 6.4875 11.625C6.44583 11.7417 6.425 11.8667 6.425 12C6.425 12.1333 6.44583 12.2583 6.4875 12.375C6.52917 12.4917 6.6 12.6 6.7 12.7L8.875 14.875C9.075 15.075 9.3125 15.175 9.5875 15.175C9.8625 15.175 10.1 15.075 10.3 14.875C10.5 14.675 10.6 14.4417 10.6 14.175C10.6 13.9083 10.5 13.675 10.3 13.475L8.825 12ZM15.175 12L13.7 13.475C13.5 13.675 13.4 13.9083 13.4 14.175C13.4 14.4417 13.5 14.675 13.7 14.875C13.9 15.075 14.1375 15.175 14.4125 15.175C14.6875 15.175 14.925 15.075 15.125 14.875L17.3 12.7C17.4 12.6 17.4708 12.4917 17.5125 12.375C17.5542 12.2583 17.575 12.1333 17.575 12C17.575 11.8667 17.5542 11.7417 17.5125 11.625C17.4708 11.5083 17.4 11.4 17.3 11.3L15.125 9.125C15.025 9.025 14.9125 8.95 14.7875 8.9C14.6625 8.85 14.5375 8.825 14.4125 8.825C14.2875 8.825 14.1625 8.85 14.0375 8.9C13.9125 8.95 13.8 9.025 13.7 9.125C13.5 9.325 13.4 9.55833 13.4 9.825C13.4 10.0917 13.5 10.325 13.7 10.525L15.175 12ZM5 21C4.45 21 3.97917 20.8042 3.5875 20.4125C3.19583 20.0208 3 19.55 3 19V5C3 4.45 3.19583 3.97917 3.5875 3.5875C3.97917 3.19583 4.45 3 5 3H19C19.55 3 20.0208 3.19583 20.4125 3.5875C20.8042 3.97917 21 4.45 21 5V19C21 19.55 20.8042 20.0208 20.4125 20.4125C20.0208 20.8042 19.55 21 19 21H5ZM5 19H19V5H5V19Z" fill="currentColor"/>', q = /* @__PURE__ */ S({
  __name: "CodeblockIcon",
  props: {
    /** The accessibility text provided to screen readers */
    title: {
      type: String,
      required: !1,
      default: ""
    },
    /** The icon color. Defaults to `currentColor` which inherits text color from the parent element */
    color: {
      type: String,
      required: !1,
      default: "currentColor"
    },
    /** The CSS display property for the icon. Defaults to `block` */
    display: {
      type: String,
      required: !1,
      default: "block"
    },
    /** Whether the icon is just eye-candy or is meaningful to the page (should screen-readers ignore the icon?) */
    decorative: {
      type: Boolean,
      required: !1,
      default: !1
    },
    /** The icon size */
    size: {
      type: [Number, String],
      required: !1,
      default: l,
      // if setting to the imported const fails, just pass a number of 24 as the default.
      validator: (i) => {
        if (typeof i == "number" && i > 0)
          return !0;
        if (typeof i == "string") {
          const e = String(i).replace(/px/gi, ""), r = Number(e);
          if (r && !isNaN(r) && Number.isInteger(r) && r > 0)
            return !0;
        }
        return !1;
      }
    },
    /** The HTML tag to utilize for the icon's wrapper element. Defaults to `span` */
    as: {
      type: String,
      required: !1,
      default: "span"
    },
    /**
     * A boolean to disable prefixing any internal SVG ids with a unique string which is done to resolve the potential for multiple SVG instances on the same page and the SVG utilizing the same ids and references internally (e.g. in the `<defs>` tag).
     * Typically only set to `true` during snapshot testing.
     * Defaults to `false`.
     */
    staticIds: {
      type: Boolean,
      default: !1
    }
  },
  setup(i) {
    const e = i, r = c(() => {
      if (typeof e.size == "number" && e.size > 0)
        return `${e.size}px`;
      if (typeof e.size == "string") {
        const n = String(e.size).replace(/px/gi, ""), t = Number(n);
        if (t && !isNaN(t) && Number.isInteger(t) && t > 0)
          return `${t}px`;
      }
      return l;
    }), C = c(() => ({
      boxSizing: "border-box",
      color: e.color,
      display: e.display,
      flexShrink: "0",
      height: r.value,
      lineHeight: "0",
      width: r.value,
      pointerEvents: e.decorative ? "none" : void 0
    })), g = (n) => {
      const t = {}, v = Math.random().toString(36).substring(2, 12);
      return n.replace(/id="([^"]+)"/g, (s, o) => {
        const a = `${v}-${o}`;
        return t[o] = a, `id="${a}"`;
      }).replace(/#([^\s^")]+)/g, (s, o) => t[o] ? `#${t[o]}` : s);
    }, p = {
      "<": "&lt;",
      ">": "&gt;",
      '"': "&quot;",
      "'": "&#39;",
      "&": "&amp;"
    }, f = (n) => n.replace(/[<>"'&]/g, (t) => p[t]), m = `${e.title ? `<title data-testid="kui-icon-svg-title">${f(e.title)}</title>` : ""}${e.staticIds ? u : g(u)}`;
    return (n, t) => (d(), b(h(i.as), {
      "aria-hidden": i.decorative ? "true" : void 0,
      class: "kui-icon codeblock-icon",
      "data-testid": "kui-icon-wrapper-codeblock-icon",
      style: y(C.value),
      tabindex: i.decorative ? "-1" : void 0
    }, {
      default: x(() => [
        (d(), k("svg", {
          "aria-hidden": i.decorative ? "true" : void 0,
          "data-testid": "kui-icon-svg-codeblock-icon",
          fill: "none",
          height: "100%",
          role: "img",
          viewBox: "0 0 24 24",
          width: "100%",
          xmlns: "http://www.w3.org/2000/svg",
          innerHTML: m
        }, null, 8, z))
      ]),
      _: 1
    }, 8, ["aria-hidden", "style", "tabindex"]));
  }
});
export {
  q as default
};
